import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useRepository } from '@/Application/Providers/Repository/Repository';

const useCustomerDataPageInitializer = () => {
  const repositories = useRepository();
  const location = useLocation();
  const pathname = location?.pathname;

  useEffect(() => {
    repositories.tokenUserIdRepository.getTokenUserId();
    repositories.cart.get();
  }, [repositories, pathname]);
};

export default useCustomerDataPageInitializer;
